import { default as indexiDHsQgFsDLMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue?macro=true";
import { default as indexuYomD2sb6UMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue?macro=true";
import { default as _91id_93bM5RBcBannMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue?macro=true";
import { default as dashboardOJj5qvCsfmMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue?macro=true";
import { default as logoutmS2xvdaxjaMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue?macro=true";
import { default as mydatakyW689J6ZlMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue?macro=true";
import { default as _91id_93ep3wd83hTdMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue?macro=true";
import { default as orderspvMGTi9kosMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue?macro=true";
import { default as wishlist57fpeC5t1JMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue?macro=true";
import { default as accountnK2vLgNrILMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/account.vue?macro=true";
import { default as createpasswordcCLBAHrG8SMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/auth/createpassword.vue?macro=true";
import { default as loginGw7OyJot9cMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/auth/login.vue?macro=true";
import { default as registerrwHlRtvuynMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/auth/register.vue?macro=true";
import { default as resetpasswordV8DNEtJhIbMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/auth/resetpassword.vue?macro=true";
import { default as _91_46_46_46slug_93kJq8nEgDEzMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/c/[...slug].vue?macro=true";
import { default as cartRovTTW5FprMeta } from "/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue?macro=true";
import { default as createBWhX2g8WKeMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/create.vue?macro=true";
import { default as indexEaXLSdig8LMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/index.vue?macro=true";
import { default as _91id_93nROaxPRGXIMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/update/[id].vue?macro=true";
import { default as addresseslw2CJ0Zy8ZMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses.vue?macro=true";
import { default as change_45passwordB6O7ZiQpSMMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/change-password.vue?macro=true";
import { default as editvxIm6yMamKMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/edit.vue?macro=true";
import { default as index75eQYyCf9xMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/index.vue?macro=true";
import { default as my_45dataVuW3hADSLNMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data.vue?macro=true";
import { default as newsletterGc4KhX2a1TMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/newsletter.vue?macro=true";
import { default as _91orderNumber_93sqP5sSbNO6Meta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/[orderNumber].vue?macro=true";
import { default as _91orderNumber_93sHWyWo8JHZMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/incident/[orderNumber].vue?macro=true";
import { default as indexOXYlYaHf9kMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/index.vue?macro=true";
import { default as _91orderNumber_93MOqVvD4dfDMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/rate/[orderNumber].vue?macro=true";
import { default as ordersbqvbcjQ8ZBMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/orders.vue?macro=true";
import { default as wishlistZxZhAvSNDpMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer/wishlist.vue?macro=true";
import { default as customerOgBGJVkF8kMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/customer.vue?macro=true";
import { default as indexO9wOAliJN5Meta } from "/home/homeyou/shc/build/build-headless/108006/pages/index.vue?macro=true";
import { default as loginBspssLFpy0Meta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue?macro=true";
import { default as index0cFktrFo8xMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis/index.vue?macro=true";
import { default as newsletter_45wypisDKgdkCoxNrMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis.vue?macro=true";
import { default as confirmQGKmBe5CKRMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/newsletter/confirm.vue?macro=true";
import { default as indexCsTmLeToj6Meta } from "/home/homeyou/shc/build/build-headless/108006/pages/newsletter/index.vue?macro=true";
import { default as removey5iSXVe4RPMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/newsletter/remove.vue?macro=true";
import { default as newsletterpBhmKYos5WMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/newsletter.vue?macro=true";
import { default as _91_46_46_46slug_93y80zYDS3wCMeta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue?macro=true";
import { default as _91id_93icNr2rgrF9Meta } from "/home/homeyou/shc/build/build-headless/108006/pages/p/[id].vue?macro=true";
import { default as registercFQtpaLLN0Meta } from "/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue?macro=true";
import { default as sT4rojxn7RxMeta } from "/home/homeyou/shc/build/build-headless/108006/pages/s.vue?macro=true";
import { default as storeLocatoriGipsFiiqFMeta } from "/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue?macro=true";
export default [
  {
    name: accountnK2vLgNrILMeta?.name ?? "account",
    path: accountnK2vLgNrILMeta?.path ?? "/account",
    children: [
  {
    name: indexiDHsQgFsDLMeta?.name ?? "account-addresses-create",
    path: indexiDHsQgFsDLMeta?.path ?? "addresses/create",
    meta: indexiDHsQgFsDLMeta || {},
    alias: indexiDHsQgFsDLMeta?.alias || [],
    redirect: indexiDHsQgFsDLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: indexuYomD2sb6UMeta?.name ?? "account-addresses",
    path: indexuYomD2sb6UMeta?.path ?? "addresses",
    meta: indexuYomD2sb6UMeta || {},
    alias: indexuYomD2sb6UMeta?.alias || [],
    redirect: indexuYomD2sb6UMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93bM5RBcBannMeta?.name ?? "account-addresses-update-id",
    path: _91id_93bM5RBcBannMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93bM5RBcBannMeta || {},
    alias: _91id_93bM5RBcBannMeta?.alias || [],
    redirect: _91id_93bM5RBcBannMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardOJj5qvCsfmMeta?.name ?? "account-dashboard",
    path: dashboardOJj5qvCsfmMeta?.path ?? "dashboard",
    meta: dashboardOJj5qvCsfmMeta || {},
    alias: dashboardOJj5qvCsfmMeta?.alias || [],
    redirect: dashboardOJj5qvCsfmMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutmS2xvdaxjaMeta?.name ?? "account-logout",
    path: logoutmS2xvdaxjaMeta?.path ?? "logout",
    meta: logoutmS2xvdaxjaMeta || {},
    alias: logoutmS2xvdaxjaMeta?.alias || [],
    redirect: logoutmS2xvdaxjaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydatakyW689J6ZlMeta?.name ?? "account-mydata",
    path: mydatakyW689J6ZlMeta?.path ?? "mydata",
    meta: mydatakyW689J6ZlMeta || {},
    alias: mydatakyW689J6ZlMeta?.alias || [],
    redirect: mydatakyW689J6ZlMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ep3wd83hTdMeta?.name ?? "account-order-id",
    path: _91id_93ep3wd83hTdMeta?.path ?? "order/:id()",
    meta: _91id_93ep3wd83hTdMeta || {},
    alias: _91id_93ep3wd83hTdMeta?.alias || [],
    redirect: _91id_93ep3wd83hTdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: orderspvMGTi9kosMeta?.name ?? "account-orders",
    path: orderspvMGTi9kosMeta?.path ?? "orders",
    meta: orderspvMGTi9kosMeta || {},
    alias: orderspvMGTi9kosMeta?.alias || [],
    redirect: orderspvMGTi9kosMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlist57fpeC5t1JMeta?.name ?? "account-wishlist",
    path: wishlist57fpeC5t1JMeta?.path ?? "wishlist",
    meta: wishlist57fpeC5t1JMeta || {},
    alias: wishlist57fpeC5t1JMeta?.alias || [],
    redirect: wishlist57fpeC5t1JMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: accountnK2vLgNrILMeta || {},
    alias: accountnK2vLgNrILMeta?.alias || [],
    redirect: accountnK2vLgNrILMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/account.vue").then(m => m.default || m)
  },
  {
    name: accountnK2vLgNrILMeta?.name ?? "account___pl",
    path: accountnK2vLgNrILMeta?.path ?? "/pl/account",
    children: [
  {
    name: indexiDHsQgFsDLMeta?.name ?? "account-addresses-create___pl",
    path: indexiDHsQgFsDLMeta?.path ?? "addresses/create",
    meta: indexiDHsQgFsDLMeta || {},
    alias: indexiDHsQgFsDLMeta?.alias || [],
    redirect: indexiDHsQgFsDLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: indexuYomD2sb6UMeta?.name ?? "account-addresses___pl",
    path: indexuYomD2sb6UMeta?.path ?? "addresses",
    meta: indexuYomD2sb6UMeta || {},
    alias: indexuYomD2sb6UMeta?.alias || [],
    redirect: indexuYomD2sb6UMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93bM5RBcBannMeta?.name ?? "account-addresses-update-id___pl",
    path: _91id_93bM5RBcBannMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93bM5RBcBannMeta || {},
    alias: _91id_93bM5RBcBannMeta?.alias || [],
    redirect: _91id_93bM5RBcBannMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardOJj5qvCsfmMeta?.name ?? "account-dashboard___pl",
    path: dashboardOJj5qvCsfmMeta?.path ?? "dashboard",
    meta: dashboardOJj5qvCsfmMeta || {},
    alias: dashboardOJj5qvCsfmMeta?.alias || [],
    redirect: dashboardOJj5qvCsfmMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutmS2xvdaxjaMeta?.name ?? "account-logout___pl",
    path: logoutmS2xvdaxjaMeta?.path ?? "logout",
    meta: logoutmS2xvdaxjaMeta || {},
    alias: logoutmS2xvdaxjaMeta?.alias || [],
    redirect: logoutmS2xvdaxjaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydatakyW689J6ZlMeta?.name ?? "account-mydata___pl",
    path: mydatakyW689J6ZlMeta?.path ?? "mydata",
    meta: mydatakyW689J6ZlMeta || {},
    alias: mydatakyW689J6ZlMeta?.alias || [],
    redirect: mydatakyW689J6ZlMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ep3wd83hTdMeta?.name ?? "account-order-id___pl",
    path: _91id_93ep3wd83hTdMeta?.path ?? "order/:id()",
    meta: _91id_93ep3wd83hTdMeta || {},
    alias: _91id_93ep3wd83hTdMeta?.alias || [],
    redirect: _91id_93ep3wd83hTdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: orderspvMGTi9kosMeta?.name ?? "account-orders___pl",
    path: orderspvMGTi9kosMeta?.path ?? "orders",
    meta: orderspvMGTi9kosMeta || {},
    alias: orderspvMGTi9kosMeta?.alias || [],
    redirect: orderspvMGTi9kosMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlist57fpeC5t1JMeta?.name ?? "account-wishlist___pl",
    path: wishlist57fpeC5t1JMeta?.path ?? "wishlist",
    meta: wishlist57fpeC5t1JMeta || {},
    alias: wishlist57fpeC5t1JMeta?.alias || [],
    redirect: wishlist57fpeC5t1JMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: accountnK2vLgNrILMeta || {},
    alias: accountnK2vLgNrILMeta?.alias || [],
    redirect: accountnK2vLgNrILMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/account.vue").then(m => m.default || m)
  },
  {
    name: accountnK2vLgNrILMeta?.name ?? "account___en",
    path: accountnK2vLgNrILMeta?.path ?? "/en/account",
    children: [
  {
    name: indexiDHsQgFsDLMeta?.name ?? "account-addresses-create___en",
    path: indexiDHsQgFsDLMeta?.path ?? "addresses/create",
    meta: indexiDHsQgFsDLMeta || {},
    alias: indexiDHsQgFsDLMeta?.alias || [],
    redirect: indexiDHsQgFsDLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: indexuYomD2sb6UMeta?.name ?? "account-addresses___en",
    path: indexuYomD2sb6UMeta?.path ?? "addresses",
    meta: indexuYomD2sb6UMeta || {},
    alias: indexuYomD2sb6UMeta?.alias || [],
    redirect: indexuYomD2sb6UMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93bM5RBcBannMeta?.name ?? "account-addresses-update-id___en",
    path: _91id_93bM5RBcBannMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93bM5RBcBannMeta || {},
    alias: _91id_93bM5RBcBannMeta?.alias || [],
    redirect: _91id_93bM5RBcBannMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardOJj5qvCsfmMeta?.name ?? "account-dashboard___en",
    path: dashboardOJj5qvCsfmMeta?.path ?? "dashboard",
    meta: dashboardOJj5qvCsfmMeta || {},
    alias: dashboardOJj5qvCsfmMeta?.alias || [],
    redirect: dashboardOJj5qvCsfmMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutmS2xvdaxjaMeta?.name ?? "account-logout___en",
    path: logoutmS2xvdaxjaMeta?.path ?? "logout",
    meta: logoutmS2xvdaxjaMeta || {},
    alias: logoutmS2xvdaxjaMeta?.alias || [],
    redirect: logoutmS2xvdaxjaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydatakyW689J6ZlMeta?.name ?? "account-mydata___en",
    path: mydatakyW689J6ZlMeta?.path ?? "mydata",
    meta: mydatakyW689J6ZlMeta || {},
    alias: mydatakyW689J6ZlMeta?.alias || [],
    redirect: mydatakyW689J6ZlMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ep3wd83hTdMeta?.name ?? "account-order-id___en",
    path: _91id_93ep3wd83hTdMeta?.path ?? "order/:id()",
    meta: _91id_93ep3wd83hTdMeta || {},
    alias: _91id_93ep3wd83hTdMeta?.alias || [],
    redirect: _91id_93ep3wd83hTdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: orderspvMGTi9kosMeta?.name ?? "account-orders___en",
    path: orderspvMGTi9kosMeta?.path ?? "orders",
    meta: orderspvMGTi9kosMeta || {},
    alias: orderspvMGTi9kosMeta?.alias || [],
    redirect: orderspvMGTi9kosMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlist57fpeC5t1JMeta?.name ?? "account-wishlist___en",
    path: wishlist57fpeC5t1JMeta?.path ?? "wishlist",
    meta: wishlist57fpeC5t1JMeta || {},
    alias: wishlist57fpeC5t1JMeta?.alias || [],
    redirect: wishlist57fpeC5t1JMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: accountnK2vLgNrILMeta || {},
    alias: accountnK2vLgNrILMeta?.alias || [],
    redirect: accountnK2vLgNrILMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/account.vue").then(m => m.default || m)
  },
  {
    name: accountnK2vLgNrILMeta?.name ?? "account___ru",
    path: accountnK2vLgNrILMeta?.path ?? "/ru/account",
    children: [
  {
    name: indexiDHsQgFsDLMeta?.name ?? "account-addresses-create___ru",
    path: indexiDHsQgFsDLMeta?.path ?? "addresses/create",
    meta: indexiDHsQgFsDLMeta || {},
    alias: indexiDHsQgFsDLMeta?.alias || [],
    redirect: indexiDHsQgFsDLMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/create/index.vue").then(m => m.default || m)
  },
  {
    name: indexuYomD2sb6UMeta?.name ?? "account-addresses___ru",
    path: indexuYomD2sb6UMeta?.path ?? "addresses",
    meta: indexuYomD2sb6UMeta || {},
    alias: indexuYomD2sb6UMeta?.alias || [],
    redirect: indexuYomD2sb6UMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93bM5RBcBannMeta?.name ?? "account-addresses-update-id___ru",
    path: _91id_93bM5RBcBannMeta?.path ?? "addresses/update/:id()",
    meta: _91id_93bM5RBcBannMeta || {},
    alias: _91id_93bM5RBcBannMeta?.alias || [],
    redirect: _91id_93bM5RBcBannMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/addresses/update/[id].vue").then(m => m.default || m)
  },
  {
    name: dashboardOJj5qvCsfmMeta?.name ?? "account-dashboard___ru",
    path: dashboardOJj5qvCsfmMeta?.path ?? "dashboard",
    meta: dashboardOJj5qvCsfmMeta || {},
    alias: dashboardOJj5qvCsfmMeta?.alias || [],
    redirect: dashboardOJj5qvCsfmMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/dashboard.vue").then(m => m.default || m)
  },
  {
    name: logoutmS2xvdaxjaMeta?.name ?? "account-logout___ru",
    path: logoutmS2xvdaxjaMeta?.path ?? "logout",
    meta: logoutmS2xvdaxjaMeta || {},
    alias: logoutmS2xvdaxjaMeta?.alias || [],
    redirect: logoutmS2xvdaxjaMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/logout.vue").then(m => m.default || m)
  },
  {
    name: mydatakyW689J6ZlMeta?.name ?? "account-mydata___ru",
    path: mydatakyW689J6ZlMeta?.path ?? "mydata",
    meta: mydatakyW689J6ZlMeta || {},
    alias: mydatakyW689J6ZlMeta?.alias || [],
    redirect: mydatakyW689J6ZlMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/mydata.vue").then(m => m.default || m)
  },
  {
    name: _91id_93ep3wd83hTdMeta?.name ?? "account-order-id___ru",
    path: _91id_93ep3wd83hTdMeta?.path ?? "order/:id()",
    meta: _91id_93ep3wd83hTdMeta || {},
    alias: _91id_93ep3wd83hTdMeta?.alias || [],
    redirect: _91id_93ep3wd83hTdMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/order/[id].vue").then(m => m.default || m)
  },
  {
    name: orderspvMGTi9kosMeta?.name ?? "account-orders___ru",
    path: orderspvMGTi9kosMeta?.path ?? "orders",
    meta: orderspvMGTi9kosMeta || {},
    alias: orderspvMGTi9kosMeta?.alias || [],
    redirect: orderspvMGTi9kosMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlist57fpeC5t1JMeta?.name ?? "account-wishlist___ru",
    path: wishlist57fpeC5t1JMeta?.path ?? "wishlist",
    meta: wishlist57fpeC5t1JMeta || {},
    alias: wishlist57fpeC5t1JMeta?.alias || [],
    redirect: wishlist57fpeC5t1JMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/account/wishlist.vue").then(m => m.default || m)
  }
],
    meta: accountnK2vLgNrILMeta || {},
    alias: accountnK2vLgNrILMeta?.alias || [],
    redirect: accountnK2vLgNrILMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/account.vue").then(m => m.default || m)
  },
  {
    name: createpasswordcCLBAHrG8SMeta?.name ?? "auth-createpassword",
    path: createpasswordcCLBAHrG8SMeta?.path ?? "/auth/createpassword",
    meta: createpasswordcCLBAHrG8SMeta || {},
    alias: createpasswordcCLBAHrG8SMeta?.alias || [],
    redirect: createpasswordcCLBAHrG8SMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: createpasswordcCLBAHrG8SMeta?.name ?? "auth-createpassword___pl",
    path: createpasswordcCLBAHrG8SMeta?.path ?? "/pl/auth/createpassword",
    meta: createpasswordcCLBAHrG8SMeta || {},
    alias: createpasswordcCLBAHrG8SMeta?.alias || [],
    redirect: createpasswordcCLBAHrG8SMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: createpasswordcCLBAHrG8SMeta?.name ?? "auth-createpassword___en",
    path: createpasswordcCLBAHrG8SMeta?.path ?? "/en/auth/createpassword",
    meta: createpasswordcCLBAHrG8SMeta || {},
    alias: createpasswordcCLBAHrG8SMeta?.alias || [],
    redirect: createpasswordcCLBAHrG8SMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: createpasswordcCLBAHrG8SMeta?.name ?? "auth-createpassword___ru",
    path: createpasswordcCLBAHrG8SMeta?.path ?? "/ru/auth/createpassword",
    meta: createpasswordcCLBAHrG8SMeta || {},
    alias: createpasswordcCLBAHrG8SMeta?.alias || [],
    redirect: createpasswordcCLBAHrG8SMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/createpassword.vue").then(m => m.default || m)
  },
  {
    name: loginGw7OyJot9cMeta?.name ?? "auth-login",
    path: loginGw7OyJot9cMeta?.path ?? "/auth/login",
    meta: loginGw7OyJot9cMeta || {},
    alias: loginGw7OyJot9cMeta?.alias || [],
    redirect: loginGw7OyJot9cMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: loginGw7OyJot9cMeta?.name ?? "auth-login___pl",
    path: loginGw7OyJot9cMeta?.path ?? "/pl/auth/login",
    meta: loginGw7OyJot9cMeta || {},
    alias: loginGw7OyJot9cMeta?.alias || [],
    redirect: loginGw7OyJot9cMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: loginGw7OyJot9cMeta?.name ?? "auth-login___en",
    path: loginGw7OyJot9cMeta?.path ?? "/en/auth/login",
    meta: loginGw7OyJot9cMeta || {},
    alias: loginGw7OyJot9cMeta?.alias || [],
    redirect: loginGw7OyJot9cMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: loginGw7OyJot9cMeta?.name ?? "auth-login___ru",
    path: loginGw7OyJot9cMeta?.path ?? "/ru/auth/login",
    meta: loginGw7OyJot9cMeta || {},
    alias: loginGw7OyJot9cMeta?.alias || [],
    redirect: loginGw7OyJot9cMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/login.vue").then(m => m.default || m)
  },
  {
    name: registerrwHlRtvuynMeta?.name ?? "auth-register",
    path: registerrwHlRtvuynMeta?.path ?? "/auth/register",
    meta: registerrwHlRtvuynMeta || {},
    alias: registerrwHlRtvuynMeta?.alias || [],
    redirect: registerrwHlRtvuynMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: registerrwHlRtvuynMeta?.name ?? "auth-register___pl",
    path: registerrwHlRtvuynMeta?.path ?? "/pl/auth/register",
    meta: registerrwHlRtvuynMeta || {},
    alias: registerrwHlRtvuynMeta?.alias || [],
    redirect: registerrwHlRtvuynMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: registerrwHlRtvuynMeta?.name ?? "auth-register___en",
    path: registerrwHlRtvuynMeta?.path ?? "/en/auth/register",
    meta: registerrwHlRtvuynMeta || {},
    alias: registerrwHlRtvuynMeta?.alias || [],
    redirect: registerrwHlRtvuynMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: registerrwHlRtvuynMeta?.name ?? "auth-register___ru",
    path: registerrwHlRtvuynMeta?.path ?? "/ru/auth/register",
    meta: registerrwHlRtvuynMeta || {},
    alias: registerrwHlRtvuynMeta?.alias || [],
    redirect: registerrwHlRtvuynMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/register.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordV8DNEtJhIbMeta?.name ?? "auth-resetpassword",
    path: resetpasswordV8DNEtJhIbMeta?.path ?? "/auth/resetpassword",
    meta: resetpasswordV8DNEtJhIbMeta || {},
    alias: resetpasswordV8DNEtJhIbMeta?.alias || [],
    redirect: resetpasswordV8DNEtJhIbMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordV8DNEtJhIbMeta?.name ?? "auth-resetpassword___pl",
    path: resetpasswordV8DNEtJhIbMeta?.path ?? "/pl/auth/resetpassword",
    meta: resetpasswordV8DNEtJhIbMeta || {},
    alias: resetpasswordV8DNEtJhIbMeta?.alias || [],
    redirect: resetpasswordV8DNEtJhIbMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordV8DNEtJhIbMeta?.name ?? "auth-resetpassword___en",
    path: resetpasswordV8DNEtJhIbMeta?.path ?? "/en/auth/resetpassword",
    meta: resetpasswordV8DNEtJhIbMeta || {},
    alias: resetpasswordV8DNEtJhIbMeta?.alias || [],
    redirect: resetpasswordV8DNEtJhIbMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: resetpasswordV8DNEtJhIbMeta?.name ?? "auth-resetpassword___ru",
    path: resetpasswordV8DNEtJhIbMeta?.path ?? "/ru/auth/resetpassword",
    meta: resetpasswordV8DNEtJhIbMeta || {},
    alias: resetpasswordV8DNEtJhIbMeta?.alias || [],
    redirect: resetpasswordV8DNEtJhIbMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/auth/resetpassword.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93kJq8nEgDEzMeta?.name ?? "c-slug",
    path: _91_46_46_46slug_93kJq8nEgDEzMeta?.path ?? "/c/:slug(.*)*",
    meta: _91_46_46_46slug_93kJq8nEgDEzMeta || {},
    alias: _91_46_46_46slug_93kJq8nEgDEzMeta?.alias || [],
    redirect: _91_46_46_46slug_93kJq8nEgDEzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93kJq8nEgDEzMeta?.name ?? "c-slug___pl",
    path: _91_46_46_46slug_93kJq8nEgDEzMeta?.path ?? "/pl/c/:slug(.*)*",
    meta: _91_46_46_46slug_93kJq8nEgDEzMeta || {},
    alias: _91_46_46_46slug_93kJq8nEgDEzMeta?.alias || [],
    redirect: _91_46_46_46slug_93kJq8nEgDEzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93kJq8nEgDEzMeta?.name ?? "c-slug___en",
    path: _91_46_46_46slug_93kJq8nEgDEzMeta?.path ?? "/en/c/:slug(.*)*",
    meta: _91_46_46_46slug_93kJq8nEgDEzMeta || {},
    alias: _91_46_46_46slug_93kJq8nEgDEzMeta?.alias || [],
    redirect: _91_46_46_46slug_93kJq8nEgDEzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93kJq8nEgDEzMeta?.name ?? "c-slug___ru",
    path: _91_46_46_46slug_93kJq8nEgDEzMeta?.path ?? "/ru/c/:slug(.*)*",
    meta: _91_46_46_46slug_93kJq8nEgDEzMeta || {},
    alias: _91_46_46_46slug_93kJq8nEgDEzMeta?.alias || [],
    redirect: _91_46_46_46slug_93kJq8nEgDEzMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: cartRovTTW5FprMeta?.name ?? "checkout-cart",
    path: cartRovTTW5FprMeta?.path ?? "/checkout/cart",
    meta: cartRovTTW5FprMeta || {},
    alias: cartRovTTW5FprMeta?.alias || [],
    redirect: cartRovTTW5FprMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: cartRovTTW5FprMeta?.name ?? "checkout-cart___pl",
    path: cartRovTTW5FprMeta?.path ?? "/pl/checkout/cart",
    meta: cartRovTTW5FprMeta || {},
    alias: cartRovTTW5FprMeta?.alias || [],
    redirect: cartRovTTW5FprMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: cartRovTTW5FprMeta?.name ?? "checkout-cart___en",
    path: cartRovTTW5FprMeta?.path ?? "/en/checkout/cart",
    meta: cartRovTTW5FprMeta || {},
    alias: cartRovTTW5FprMeta?.alias || [],
    redirect: cartRovTTW5FprMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: cartRovTTW5FprMeta?.name ?? "checkout-cart___ru",
    path: cartRovTTW5FprMeta?.path ?? "/ru/checkout/cart",
    meta: cartRovTTW5FprMeta || {},
    alias: cartRovTTW5FprMeta?.alias || [],
    redirect: cartRovTTW5FprMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-cart-layer/pages/checkout/cart.vue").then(m => m.default || m)
  },
  {
    name: customerOgBGJVkF8kMeta?.name ?? "customer",
    path: customerOgBGJVkF8kMeta?.path ?? "/customer",
    children: [
  {
    path: addresseslw2CJ0Zy8ZMeta?.path ?? "addresses",
    children: [
  {
    name: createBWhX2g8WKeMeta?.name ?? "customer-addresses-create",
    path: createBWhX2g8WKeMeta?.path ?? "create",
    meta: createBWhX2g8WKeMeta || {},
    alias: createBWhX2g8WKeMeta?.alias || [],
    redirect: createBWhX2g8WKeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexEaXLSdig8LMeta?.name ?? "customer-addresses",
    path: indexEaXLSdig8LMeta?.path ?? "",
    meta: indexEaXLSdig8LMeta || {},
    alias: indexEaXLSdig8LMeta?.alias || [],
    redirect: indexEaXLSdig8LMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nROaxPRGXIMeta?.name ?? "customer-addresses-update-id",
    path: _91id_93nROaxPRGXIMeta?.path ?? "update/:id()",
    meta: _91id_93nROaxPRGXIMeta || {},
    alias: _91id_93nROaxPRGXIMeta?.alias || [],
    redirect: _91id_93nROaxPRGXIMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addresseslw2CJ0Zy8ZMeta?.name ?? undefined,
    meta: addresseslw2CJ0Zy8ZMeta || {},
    alias: addresseslw2CJ0Zy8ZMeta?.alias || [],
    redirect: addresseslw2CJ0Zy8ZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataVuW3hADSLNMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordB6O7ZiQpSMMeta?.name ?? "customer-my-data-change-password",
    path: change_45passwordB6O7ZiQpSMMeta?.path ?? "change-password",
    meta: change_45passwordB6O7ZiQpSMMeta || {},
    alias: change_45passwordB6O7ZiQpSMMeta?.alias || [],
    redirect: change_45passwordB6O7ZiQpSMMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editvxIm6yMamKMeta?.name ?? "customer-my-data-edit",
    path: editvxIm6yMamKMeta?.path ?? "edit",
    meta: editvxIm6yMamKMeta || {},
    alias: editvxIm6yMamKMeta?.alias || [],
    redirect: editvxIm6yMamKMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index75eQYyCf9xMeta?.name ?? "customer-my-data",
    path: index75eQYyCf9xMeta?.path ?? "",
    meta: index75eQYyCf9xMeta || {},
    alias: index75eQYyCf9xMeta?.alias || [],
    redirect: index75eQYyCf9xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataVuW3hADSLNMeta?.name ?? undefined,
    meta: my_45dataVuW3hADSLNMeta || {},
    alias: my_45dataVuW3hADSLNMeta?.alias || [],
    redirect: my_45dataVuW3hADSLNMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterGc4KhX2a1TMeta?.name ?? "customer-newsletter",
    path: newsletterGc4KhX2a1TMeta?.path ?? "newsletter",
    meta: newsletterGc4KhX2a1TMeta || {},
    alias: newsletterGc4KhX2a1TMeta?.alias || [],
    redirect: newsletterGc4KhX2a1TMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersbqvbcjQ8ZBMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93sqP5sSbNO6Meta?.name ?? "customer-orders-orderNumber",
    path: _91orderNumber_93sqP5sSbNO6Meta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93sqP5sSbNO6Meta || {},
    alias: _91orderNumber_93sqP5sSbNO6Meta?.alias || [],
    redirect: _91orderNumber_93sqP5sSbNO6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93sHWyWo8JHZMeta?.name ?? "customer-orders-incident-orderNumber",
    path: _91orderNumber_93sHWyWo8JHZMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93sHWyWo8JHZMeta || {},
    alias: _91orderNumber_93sHWyWo8JHZMeta?.alias || [],
    redirect: _91orderNumber_93sHWyWo8JHZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexOXYlYaHf9kMeta?.name ?? "customer-orders",
    path: indexOXYlYaHf9kMeta?.path ?? "",
    meta: indexOXYlYaHf9kMeta || {},
    alias: indexOXYlYaHf9kMeta?.alias || [],
    redirect: indexOXYlYaHf9kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93MOqVvD4dfDMeta?.name ?? "customer-orders-rate-orderNumber",
    path: _91orderNumber_93MOqVvD4dfDMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93MOqVvD4dfDMeta || {},
    alias: _91orderNumber_93MOqVvD4dfDMeta?.alias || [],
    redirect: _91orderNumber_93MOqVvD4dfDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersbqvbcjQ8ZBMeta?.name ?? undefined,
    meta: ordersbqvbcjQ8ZBMeta || {},
    alias: ordersbqvbcjQ8ZBMeta?.alias || [],
    redirect: ordersbqvbcjQ8ZBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistZxZhAvSNDpMeta?.name ?? "customer-wishlist",
    path: wishlistZxZhAvSNDpMeta?.path ?? "wishlist",
    meta: wishlistZxZhAvSNDpMeta || {},
    alias: wishlistZxZhAvSNDpMeta?.alias || [],
    redirect: wishlistZxZhAvSNDpMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerOgBGJVkF8kMeta || {},
    alias: customerOgBGJVkF8kMeta?.alias || [],
    redirect: customerOgBGJVkF8kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: customerOgBGJVkF8kMeta?.name ?? "customer___pl",
    path: customerOgBGJVkF8kMeta?.path ?? "/pl/customer",
    children: [
  {
    path: addresseslw2CJ0Zy8ZMeta?.path ?? "addresses",
    children: [
  {
    name: createBWhX2g8WKeMeta?.name ?? "customer-addresses-create___pl",
    path: createBWhX2g8WKeMeta?.path ?? "create",
    meta: createBWhX2g8WKeMeta || {},
    alias: createBWhX2g8WKeMeta?.alias || [],
    redirect: createBWhX2g8WKeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexEaXLSdig8LMeta?.name ?? "customer-addresses___pl",
    path: indexEaXLSdig8LMeta?.path ?? "",
    meta: indexEaXLSdig8LMeta || {},
    alias: indexEaXLSdig8LMeta?.alias || [],
    redirect: indexEaXLSdig8LMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nROaxPRGXIMeta?.name ?? "customer-addresses-update-id___pl",
    path: _91id_93nROaxPRGXIMeta?.path ?? "update/:id()",
    meta: _91id_93nROaxPRGXIMeta || {},
    alias: _91id_93nROaxPRGXIMeta?.alias || [],
    redirect: _91id_93nROaxPRGXIMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addresseslw2CJ0Zy8ZMeta?.name ?? undefined,
    meta: addresseslw2CJ0Zy8ZMeta || {},
    alias: addresseslw2CJ0Zy8ZMeta?.alias || [],
    redirect: addresseslw2CJ0Zy8ZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataVuW3hADSLNMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordB6O7ZiQpSMMeta?.name ?? "customer-my-data-change-password___pl",
    path: change_45passwordB6O7ZiQpSMMeta?.path ?? "change-password",
    meta: change_45passwordB6O7ZiQpSMMeta || {},
    alias: change_45passwordB6O7ZiQpSMMeta?.alias || [],
    redirect: change_45passwordB6O7ZiQpSMMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editvxIm6yMamKMeta?.name ?? "customer-my-data-edit___pl",
    path: editvxIm6yMamKMeta?.path ?? "edit",
    meta: editvxIm6yMamKMeta || {},
    alias: editvxIm6yMamKMeta?.alias || [],
    redirect: editvxIm6yMamKMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index75eQYyCf9xMeta?.name ?? "customer-my-data___pl",
    path: index75eQYyCf9xMeta?.path ?? "",
    meta: index75eQYyCf9xMeta || {},
    alias: index75eQYyCf9xMeta?.alias || [],
    redirect: index75eQYyCf9xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataVuW3hADSLNMeta?.name ?? undefined,
    meta: my_45dataVuW3hADSLNMeta || {},
    alias: my_45dataVuW3hADSLNMeta?.alias || [],
    redirect: my_45dataVuW3hADSLNMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterGc4KhX2a1TMeta?.name ?? "customer-newsletter___pl",
    path: newsletterGc4KhX2a1TMeta?.path ?? "newsletter",
    meta: newsletterGc4KhX2a1TMeta || {},
    alias: newsletterGc4KhX2a1TMeta?.alias || [],
    redirect: newsletterGc4KhX2a1TMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersbqvbcjQ8ZBMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93sqP5sSbNO6Meta?.name ?? "customer-orders-orderNumber___pl",
    path: _91orderNumber_93sqP5sSbNO6Meta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93sqP5sSbNO6Meta || {},
    alias: _91orderNumber_93sqP5sSbNO6Meta?.alias || [],
    redirect: _91orderNumber_93sqP5sSbNO6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93sHWyWo8JHZMeta?.name ?? "customer-orders-incident-orderNumber___pl",
    path: _91orderNumber_93sHWyWo8JHZMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93sHWyWo8JHZMeta || {},
    alias: _91orderNumber_93sHWyWo8JHZMeta?.alias || [],
    redirect: _91orderNumber_93sHWyWo8JHZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexOXYlYaHf9kMeta?.name ?? "customer-orders___pl",
    path: indexOXYlYaHf9kMeta?.path ?? "",
    meta: indexOXYlYaHf9kMeta || {},
    alias: indexOXYlYaHf9kMeta?.alias || [],
    redirect: indexOXYlYaHf9kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93MOqVvD4dfDMeta?.name ?? "customer-orders-rate-orderNumber___pl",
    path: _91orderNumber_93MOqVvD4dfDMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93MOqVvD4dfDMeta || {},
    alias: _91orderNumber_93MOqVvD4dfDMeta?.alias || [],
    redirect: _91orderNumber_93MOqVvD4dfDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersbqvbcjQ8ZBMeta?.name ?? undefined,
    meta: ordersbqvbcjQ8ZBMeta || {},
    alias: ordersbqvbcjQ8ZBMeta?.alias || [],
    redirect: ordersbqvbcjQ8ZBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistZxZhAvSNDpMeta?.name ?? "customer-wishlist___pl",
    path: wishlistZxZhAvSNDpMeta?.path ?? "wishlist",
    meta: wishlistZxZhAvSNDpMeta || {},
    alias: wishlistZxZhAvSNDpMeta?.alias || [],
    redirect: wishlistZxZhAvSNDpMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerOgBGJVkF8kMeta || {},
    alias: customerOgBGJVkF8kMeta?.alias || [],
    redirect: customerOgBGJVkF8kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: customerOgBGJVkF8kMeta?.name ?? "customer___en",
    path: customerOgBGJVkF8kMeta?.path ?? "/en/customer",
    children: [
  {
    path: addresseslw2CJ0Zy8ZMeta?.path ?? "addresses",
    children: [
  {
    name: createBWhX2g8WKeMeta?.name ?? "customer-addresses-create___en",
    path: createBWhX2g8WKeMeta?.path ?? "create",
    meta: createBWhX2g8WKeMeta || {},
    alias: createBWhX2g8WKeMeta?.alias || [],
    redirect: createBWhX2g8WKeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexEaXLSdig8LMeta?.name ?? "customer-addresses___en",
    path: indexEaXLSdig8LMeta?.path ?? "",
    meta: indexEaXLSdig8LMeta || {},
    alias: indexEaXLSdig8LMeta?.alias || [],
    redirect: indexEaXLSdig8LMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nROaxPRGXIMeta?.name ?? "customer-addresses-update-id___en",
    path: _91id_93nROaxPRGXIMeta?.path ?? "update/:id()",
    meta: _91id_93nROaxPRGXIMeta || {},
    alias: _91id_93nROaxPRGXIMeta?.alias || [],
    redirect: _91id_93nROaxPRGXIMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addresseslw2CJ0Zy8ZMeta?.name ?? undefined,
    meta: addresseslw2CJ0Zy8ZMeta || {},
    alias: addresseslw2CJ0Zy8ZMeta?.alias || [],
    redirect: addresseslw2CJ0Zy8ZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataVuW3hADSLNMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordB6O7ZiQpSMMeta?.name ?? "customer-my-data-change-password___en",
    path: change_45passwordB6O7ZiQpSMMeta?.path ?? "change-password",
    meta: change_45passwordB6O7ZiQpSMMeta || {},
    alias: change_45passwordB6O7ZiQpSMMeta?.alias || [],
    redirect: change_45passwordB6O7ZiQpSMMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editvxIm6yMamKMeta?.name ?? "customer-my-data-edit___en",
    path: editvxIm6yMamKMeta?.path ?? "edit",
    meta: editvxIm6yMamKMeta || {},
    alias: editvxIm6yMamKMeta?.alias || [],
    redirect: editvxIm6yMamKMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index75eQYyCf9xMeta?.name ?? "customer-my-data___en",
    path: index75eQYyCf9xMeta?.path ?? "",
    meta: index75eQYyCf9xMeta || {},
    alias: index75eQYyCf9xMeta?.alias || [],
    redirect: index75eQYyCf9xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataVuW3hADSLNMeta?.name ?? undefined,
    meta: my_45dataVuW3hADSLNMeta || {},
    alias: my_45dataVuW3hADSLNMeta?.alias || [],
    redirect: my_45dataVuW3hADSLNMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterGc4KhX2a1TMeta?.name ?? "customer-newsletter___en",
    path: newsletterGc4KhX2a1TMeta?.path ?? "newsletter",
    meta: newsletterGc4KhX2a1TMeta || {},
    alias: newsletterGc4KhX2a1TMeta?.alias || [],
    redirect: newsletterGc4KhX2a1TMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersbqvbcjQ8ZBMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93sqP5sSbNO6Meta?.name ?? "customer-orders-orderNumber___en",
    path: _91orderNumber_93sqP5sSbNO6Meta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93sqP5sSbNO6Meta || {},
    alias: _91orderNumber_93sqP5sSbNO6Meta?.alias || [],
    redirect: _91orderNumber_93sqP5sSbNO6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93sHWyWo8JHZMeta?.name ?? "customer-orders-incident-orderNumber___en",
    path: _91orderNumber_93sHWyWo8JHZMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93sHWyWo8JHZMeta || {},
    alias: _91orderNumber_93sHWyWo8JHZMeta?.alias || [],
    redirect: _91orderNumber_93sHWyWo8JHZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexOXYlYaHf9kMeta?.name ?? "customer-orders___en",
    path: indexOXYlYaHf9kMeta?.path ?? "",
    meta: indexOXYlYaHf9kMeta || {},
    alias: indexOXYlYaHf9kMeta?.alias || [],
    redirect: indexOXYlYaHf9kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93MOqVvD4dfDMeta?.name ?? "customer-orders-rate-orderNumber___en",
    path: _91orderNumber_93MOqVvD4dfDMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93MOqVvD4dfDMeta || {},
    alias: _91orderNumber_93MOqVvD4dfDMeta?.alias || [],
    redirect: _91orderNumber_93MOqVvD4dfDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersbqvbcjQ8ZBMeta?.name ?? undefined,
    meta: ordersbqvbcjQ8ZBMeta || {},
    alias: ordersbqvbcjQ8ZBMeta?.alias || [],
    redirect: ordersbqvbcjQ8ZBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistZxZhAvSNDpMeta?.name ?? "customer-wishlist___en",
    path: wishlistZxZhAvSNDpMeta?.path ?? "wishlist",
    meta: wishlistZxZhAvSNDpMeta || {},
    alias: wishlistZxZhAvSNDpMeta?.alias || [],
    redirect: wishlistZxZhAvSNDpMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerOgBGJVkF8kMeta || {},
    alias: customerOgBGJVkF8kMeta?.alias || [],
    redirect: customerOgBGJVkF8kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: customerOgBGJVkF8kMeta?.name ?? "customer___ru",
    path: customerOgBGJVkF8kMeta?.path ?? "/ru/customer",
    children: [
  {
    path: addresseslw2CJ0Zy8ZMeta?.path ?? "addresses",
    children: [
  {
    name: createBWhX2g8WKeMeta?.name ?? "customer-addresses-create___ru",
    path: createBWhX2g8WKeMeta?.path ?? "create",
    meta: createBWhX2g8WKeMeta || {},
    alias: createBWhX2g8WKeMeta?.alias || [],
    redirect: createBWhX2g8WKeMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/create.vue").then(m => m.default || m)
  },
  {
    name: indexEaXLSdig8LMeta?.name ?? "customer-addresses___ru",
    path: indexEaXLSdig8LMeta?.path ?? "",
    meta: indexEaXLSdig8LMeta || {},
    alias: indexEaXLSdig8LMeta?.alias || [],
    redirect: indexEaXLSdig8LMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93nROaxPRGXIMeta?.name ?? "customer-addresses-update-id___ru",
    path: _91id_93nROaxPRGXIMeta?.path ?? "update/:id()",
    meta: _91id_93nROaxPRGXIMeta || {},
    alias: _91id_93nROaxPRGXIMeta?.alias || [],
    redirect: _91id_93nROaxPRGXIMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses/update/[id].vue").then(m => m.default || m)
  }
],
    name: addresseslw2CJ0Zy8ZMeta?.name ?? undefined,
    meta: addresseslw2CJ0Zy8ZMeta || {},
    alias: addresseslw2CJ0Zy8ZMeta?.alias || [],
    redirect: addresseslw2CJ0Zy8ZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/addresses.vue").then(m => m.default || m)
  },
  {
    path: my_45dataVuW3hADSLNMeta?.path ?? "my-data",
    children: [
  {
    name: change_45passwordB6O7ZiQpSMMeta?.name ?? "customer-my-data-change-password___ru",
    path: change_45passwordB6O7ZiQpSMMeta?.path ?? "change-password",
    meta: change_45passwordB6O7ZiQpSMMeta || {},
    alias: change_45passwordB6O7ZiQpSMMeta?.alias || [],
    redirect: change_45passwordB6O7ZiQpSMMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/change-password.vue").then(m => m.default || m)
  },
  {
    name: editvxIm6yMamKMeta?.name ?? "customer-my-data-edit___ru",
    path: editvxIm6yMamKMeta?.path ?? "edit",
    meta: editvxIm6yMamKMeta || {},
    alias: editvxIm6yMamKMeta?.alias || [],
    redirect: editvxIm6yMamKMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/edit.vue").then(m => m.default || m)
  },
  {
    name: index75eQYyCf9xMeta?.name ?? "customer-my-data___ru",
    path: index75eQYyCf9xMeta?.path ?? "",
    meta: index75eQYyCf9xMeta || {},
    alias: index75eQYyCf9xMeta?.alias || [],
    redirect: index75eQYyCf9xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data/index.vue").then(m => m.default || m)
  }
],
    name: my_45dataVuW3hADSLNMeta?.name ?? undefined,
    meta: my_45dataVuW3hADSLNMeta || {},
    alias: my_45dataVuW3hADSLNMeta?.alias || [],
    redirect: my_45dataVuW3hADSLNMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/my-data.vue").then(m => m.default || m)
  },
  {
    name: newsletterGc4KhX2a1TMeta?.name ?? "customer-newsletter___ru",
    path: newsletterGc4KhX2a1TMeta?.path ?? "newsletter",
    meta: newsletterGc4KhX2a1TMeta || {},
    alias: newsletterGc4KhX2a1TMeta?.alias || [],
    redirect: newsletterGc4KhX2a1TMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/newsletter.vue").then(m => m.default || m)
  },
  {
    path: ordersbqvbcjQ8ZBMeta?.path ?? "orders",
    children: [
  {
    name: _91orderNumber_93sqP5sSbNO6Meta?.name ?? "customer-orders-orderNumber___ru",
    path: _91orderNumber_93sqP5sSbNO6Meta?.path ?? ":orderNumber()",
    meta: _91orderNumber_93sqP5sSbNO6Meta || {},
    alias: _91orderNumber_93sqP5sSbNO6Meta?.alias || [],
    redirect: _91orderNumber_93sqP5sSbNO6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93sHWyWo8JHZMeta?.name ?? "customer-orders-incident-orderNumber___ru",
    path: _91orderNumber_93sHWyWo8JHZMeta?.path ?? "incident/:orderNumber()",
    meta: _91orderNumber_93sHWyWo8JHZMeta || {},
    alias: _91orderNumber_93sHWyWo8JHZMeta?.alias || [],
    redirect: _91orderNumber_93sHWyWo8JHZMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/incident/[orderNumber].vue").then(m => m.default || m)
  },
  {
    name: indexOXYlYaHf9kMeta?.name ?? "customer-orders___ru",
    path: indexOXYlYaHf9kMeta?.path ?? "",
    meta: indexOXYlYaHf9kMeta || {},
    alias: indexOXYlYaHf9kMeta?.alias || [],
    redirect: indexOXYlYaHf9kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderNumber_93MOqVvD4dfDMeta?.name ?? "customer-orders-rate-orderNumber___ru",
    path: _91orderNumber_93MOqVvD4dfDMeta?.path ?? "rate/:orderNumber()",
    meta: _91orderNumber_93MOqVvD4dfDMeta || {},
    alias: _91orderNumber_93MOqVvD4dfDMeta?.alias || [],
    redirect: _91orderNumber_93MOqVvD4dfDMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders/rate/[orderNumber].vue").then(m => m.default || m)
  }
],
    name: ordersbqvbcjQ8ZBMeta?.name ?? undefined,
    meta: ordersbqvbcjQ8ZBMeta || {},
    alias: ordersbqvbcjQ8ZBMeta?.alias || [],
    redirect: ordersbqvbcjQ8ZBMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/orders.vue").then(m => m.default || m)
  },
  {
    name: wishlistZxZhAvSNDpMeta?.name ?? "customer-wishlist___ru",
    path: wishlistZxZhAvSNDpMeta?.path ?? "wishlist",
    meta: wishlistZxZhAvSNDpMeta || {},
    alias: wishlistZxZhAvSNDpMeta?.alias || [],
    redirect: wishlistZxZhAvSNDpMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer/wishlist.vue").then(m => m.default || m)
  }
],
    meta: customerOgBGJVkF8kMeta || {},
    alias: customerOgBGJVkF8kMeta?.alias || [],
    redirect: customerOgBGJVkF8kMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/customer.vue").then(m => m.default || m)
  },
  {
    name: indexO9wOAliJN5Meta?.name ?? "index",
    path: indexO9wOAliJN5Meta?.path ?? "/",
    meta: indexO9wOAliJN5Meta || {},
    alias: indexO9wOAliJN5Meta?.alias || [],
    redirect: indexO9wOAliJN5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexO9wOAliJN5Meta?.name ?? "index___pl",
    path: indexO9wOAliJN5Meta?.path ?? "/pl",
    meta: indexO9wOAliJN5Meta || {},
    alias: indexO9wOAliJN5Meta?.alias || [],
    redirect: indexO9wOAliJN5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexO9wOAliJN5Meta?.name ?? "index___en",
    path: indexO9wOAliJN5Meta?.path ?? "/en",
    meta: indexO9wOAliJN5Meta || {},
    alias: indexO9wOAliJN5Meta?.alias || [],
    redirect: indexO9wOAliJN5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexO9wOAliJN5Meta?.name ?? "index___ru",
    path: indexO9wOAliJN5Meta?.path ?? "/ru",
    meta: indexO9wOAliJN5Meta || {},
    alias: indexO9wOAliJN5Meta?.alias || [],
    redirect: indexO9wOAliJN5Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginBspssLFpy0Meta?.name ?? "login",
    path: loginBspssLFpy0Meta?.path ?? "/login",
    meta: loginBspssLFpy0Meta || {},
    alias: loginBspssLFpy0Meta?.alias || [],
    redirect: loginBspssLFpy0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginBspssLFpy0Meta?.name ?? "login___pl",
    path: loginBspssLFpy0Meta?.path ?? "/pl/login",
    meta: loginBspssLFpy0Meta || {},
    alias: loginBspssLFpy0Meta?.alias || [],
    redirect: loginBspssLFpy0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginBspssLFpy0Meta?.name ?? "login___en",
    path: loginBspssLFpy0Meta?.path ?? "/en/login",
    meta: loginBspssLFpy0Meta || {},
    alias: loginBspssLFpy0Meta?.alias || [],
    redirect: loginBspssLFpy0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginBspssLFpy0Meta?.name ?? "login___ru",
    path: loginBspssLFpy0Meta?.path ?? "/ru/login",
    meta: loginBspssLFpy0Meta || {},
    alias: loginBspssLFpy0Meta?.alias || [],
    redirect: loginBspssLFpy0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/login.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisDKgdkCoxNrMeta?.path ?? "/newsletter-wypis",
    children: [
  {
    name: index0cFktrFo8xMeta?.name ?? "newsletter-wypis",
    path: index0cFktrFo8xMeta?.path ?? "",
    meta: index0cFktrFo8xMeta || {},
    alias: index0cFktrFo8xMeta?.alias || [],
    redirect: index0cFktrFo8xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisDKgdkCoxNrMeta?.name ?? undefined,
    meta: newsletter_45wypisDKgdkCoxNrMeta || {},
    alias: newsletter_45wypisDKgdkCoxNrMeta?.alias || [],
    redirect: newsletter_45wypisDKgdkCoxNrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisDKgdkCoxNrMeta?.path ?? "/pl/newsletter-wypis",
    children: [
  {
    name: index0cFktrFo8xMeta?.name ?? "newsletter-wypis___pl",
    path: index0cFktrFo8xMeta?.path ?? "",
    meta: index0cFktrFo8xMeta || {},
    alias: index0cFktrFo8xMeta?.alias || [],
    redirect: index0cFktrFo8xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisDKgdkCoxNrMeta?.name ?? undefined,
    meta: newsletter_45wypisDKgdkCoxNrMeta || {},
    alias: newsletter_45wypisDKgdkCoxNrMeta?.alias || [],
    redirect: newsletter_45wypisDKgdkCoxNrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisDKgdkCoxNrMeta?.path ?? "/en/newsletter-wypis",
    children: [
  {
    name: index0cFktrFo8xMeta?.name ?? "newsletter-wypis___en",
    path: index0cFktrFo8xMeta?.path ?? "",
    meta: index0cFktrFo8xMeta || {},
    alias: index0cFktrFo8xMeta?.alias || [],
    redirect: index0cFktrFo8xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisDKgdkCoxNrMeta?.name ?? undefined,
    meta: newsletter_45wypisDKgdkCoxNrMeta || {},
    alias: newsletter_45wypisDKgdkCoxNrMeta?.alias || [],
    redirect: newsletter_45wypisDKgdkCoxNrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletter_45wypisDKgdkCoxNrMeta?.path ?? "/ru/newsletter-wypis",
    children: [
  {
    name: index0cFktrFo8xMeta?.name ?? "newsletter-wypis___ru",
    path: index0cFktrFo8xMeta?.path ?? "",
    meta: index0cFktrFo8xMeta || {},
    alias: index0cFktrFo8xMeta?.alias || [],
    redirect: index0cFktrFo8xMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis/index.vue").then(m => m.default || m)
  }
],
    name: newsletter_45wypisDKgdkCoxNrMeta?.name ?? undefined,
    meta: newsletter_45wypisDKgdkCoxNrMeta || {},
    alias: newsletter_45wypisDKgdkCoxNrMeta?.alias || [],
    redirect: newsletter_45wypisDKgdkCoxNrMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter-wypis.vue").then(m => m.default || m)
  },
  {
    path: newsletterpBhmKYos5WMeta?.path ?? "/newsletter",
    children: [
  {
    name: confirmQGKmBe5CKRMeta?.name ?? "newsletter-confirm",
    path: confirmQGKmBe5CKRMeta?.path ?? "confirm",
    meta: confirmQGKmBe5CKRMeta || {},
    alias: confirmQGKmBe5CKRMeta?.alias || [],
    redirect: confirmQGKmBe5CKRMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexCsTmLeToj6Meta?.name ?? "newsletter",
    path: indexCsTmLeToj6Meta?.path ?? "",
    meta: indexCsTmLeToj6Meta || {},
    alias: indexCsTmLeToj6Meta?.alias || [],
    redirect: indexCsTmLeToj6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: removey5iSXVe4RPMeta?.name ?? "newsletter-remove",
    path: removey5iSXVe4RPMeta?.path ?? "remove",
    meta: removey5iSXVe4RPMeta || {},
    alias: removey5iSXVe4RPMeta?.alias || [],
    redirect: removey5iSXVe4RPMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterpBhmKYos5WMeta?.name ?? undefined,
    meta: newsletterpBhmKYos5WMeta || {},
    alias: newsletterpBhmKYos5WMeta?.alias || [],
    redirect: newsletterpBhmKYos5WMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    path: newsletterpBhmKYos5WMeta?.path ?? "/pl/newsletter",
    children: [
  {
    name: confirmQGKmBe5CKRMeta?.name ?? "newsletter-confirm___pl",
    path: confirmQGKmBe5CKRMeta?.path ?? "confirm",
    meta: confirmQGKmBe5CKRMeta || {},
    alias: confirmQGKmBe5CKRMeta?.alias || [],
    redirect: confirmQGKmBe5CKRMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexCsTmLeToj6Meta?.name ?? "newsletter___pl",
    path: indexCsTmLeToj6Meta?.path ?? "",
    meta: indexCsTmLeToj6Meta || {},
    alias: indexCsTmLeToj6Meta?.alias || [],
    redirect: indexCsTmLeToj6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: removey5iSXVe4RPMeta?.name ?? "newsletter-remove___pl",
    path: removey5iSXVe4RPMeta?.path ?? "remove",
    meta: removey5iSXVe4RPMeta || {},
    alias: removey5iSXVe4RPMeta?.alias || [],
    redirect: removey5iSXVe4RPMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterpBhmKYos5WMeta?.name ?? undefined,
    meta: newsletterpBhmKYos5WMeta || {},
    alias: newsletterpBhmKYos5WMeta?.alias || [],
    redirect: newsletterpBhmKYos5WMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    path: newsletterpBhmKYos5WMeta?.path ?? "/en/newsletter",
    children: [
  {
    name: confirmQGKmBe5CKRMeta?.name ?? "newsletter-confirm___en",
    path: confirmQGKmBe5CKRMeta?.path ?? "confirm",
    meta: confirmQGKmBe5CKRMeta || {},
    alias: confirmQGKmBe5CKRMeta?.alias || [],
    redirect: confirmQGKmBe5CKRMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexCsTmLeToj6Meta?.name ?? "newsletter___en",
    path: indexCsTmLeToj6Meta?.path ?? "",
    meta: indexCsTmLeToj6Meta || {},
    alias: indexCsTmLeToj6Meta?.alias || [],
    redirect: indexCsTmLeToj6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: removey5iSXVe4RPMeta?.name ?? "newsletter-remove___en",
    path: removey5iSXVe4RPMeta?.path ?? "remove",
    meta: removey5iSXVe4RPMeta || {},
    alias: removey5iSXVe4RPMeta?.alias || [],
    redirect: removey5iSXVe4RPMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterpBhmKYos5WMeta?.name ?? undefined,
    meta: newsletterpBhmKYos5WMeta || {},
    alias: newsletterpBhmKYos5WMeta?.alias || [],
    redirect: newsletterpBhmKYos5WMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    path: newsletterpBhmKYos5WMeta?.path ?? "/ru/newsletter",
    children: [
  {
    name: confirmQGKmBe5CKRMeta?.name ?? "newsletter-confirm___ru",
    path: confirmQGKmBe5CKRMeta?.path ?? "confirm",
    meta: confirmQGKmBe5CKRMeta || {},
    alias: confirmQGKmBe5CKRMeta?.alias || [],
    redirect: confirmQGKmBe5CKRMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/confirm.vue").then(m => m.default || m)
  },
  {
    name: indexCsTmLeToj6Meta?.name ?? "newsletter___ru",
    path: indexCsTmLeToj6Meta?.path ?? "",
    meta: indexCsTmLeToj6Meta || {},
    alias: indexCsTmLeToj6Meta?.alias || [],
    redirect: indexCsTmLeToj6Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/index.vue").then(m => m.default || m)
  },
  {
    name: removey5iSXVe4RPMeta?.name ?? "newsletter-remove___ru",
    path: removey5iSXVe4RPMeta?.path ?? "remove",
    meta: removey5iSXVe4RPMeta || {},
    alias: removey5iSXVe4RPMeta?.alias || [],
    redirect: removey5iSXVe4RPMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter/remove.vue").then(m => m.default || m)
  }
],
    name: newsletterpBhmKYos5WMeta?.name ?? undefined,
    meta: newsletterpBhmKYos5WMeta || {},
    alias: newsletterpBhmKYos5WMeta?.alias || [],
    redirect: newsletterpBhmKYos5WMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/newsletter.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93y80zYDS3wCMeta?.name ?? "p-slug",
    path: _91_46_46_46slug_93y80zYDS3wCMeta?.path ?? "/p/:slug(.*)*",
    meta: _91_46_46_46slug_93y80zYDS3wCMeta || {},
    alias: _91_46_46_46slug_93y80zYDS3wCMeta?.alias || [],
    redirect: _91_46_46_46slug_93y80zYDS3wCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93y80zYDS3wCMeta?.name ?? "p-slug___pl",
    path: _91_46_46_46slug_93y80zYDS3wCMeta?.path ?? "/pl/p/:slug(.*)*",
    meta: _91_46_46_46slug_93y80zYDS3wCMeta || {},
    alias: _91_46_46_46slug_93y80zYDS3wCMeta?.alias || [],
    redirect: _91_46_46_46slug_93y80zYDS3wCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93y80zYDS3wCMeta?.name ?? "p-slug___en",
    path: _91_46_46_46slug_93y80zYDS3wCMeta?.path ?? "/en/p/:slug(.*)*",
    meta: _91_46_46_46slug_93y80zYDS3wCMeta || {},
    alias: _91_46_46_46slug_93y80zYDS3wCMeta?.alias || [],
    redirect: _91_46_46_46slug_93y80zYDS3wCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93y80zYDS3wCMeta?.name ?? "p-slug___ru",
    path: _91_46_46_46slug_93y80zYDS3wCMeta?.path ?? "/ru/p/:slug(.*)*",
    meta: _91_46_46_46slug_93y80zYDS3wCMeta || {},
    alias: _91_46_46_46slug_93y80zYDS3wCMeta?.alias || [],
    redirect: _91_46_46_46slug_93y80zYDS3wCMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-product-page-layer/pages/p/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91id_93icNr2rgrF9Meta?.name ?? "p-id",
    path: _91id_93icNr2rgrF9Meta?.path ?? "/p/:id()",
    meta: _91id_93icNr2rgrF9Meta || {},
    alias: _91id_93icNr2rgrF9Meta?.alias || [],
    redirect: _91id_93icNr2rgrF9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93icNr2rgrF9Meta?.name ?? "p-id___pl",
    path: _91id_93icNr2rgrF9Meta?.path ?? "/pl/p/:id()",
    meta: _91id_93icNr2rgrF9Meta || {},
    alias: _91id_93icNr2rgrF9Meta?.alias || [],
    redirect: _91id_93icNr2rgrF9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93icNr2rgrF9Meta?.name ?? "p-id___en",
    path: _91id_93icNr2rgrF9Meta?.path ?? "/en/p/:id()",
    meta: _91id_93icNr2rgrF9Meta || {},
    alias: _91id_93icNr2rgrF9Meta?.alias || [],
    redirect: _91id_93icNr2rgrF9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93icNr2rgrF9Meta?.name ?? "p-id___ru",
    path: _91id_93icNr2rgrF9Meta?.path ?? "/ru/p/:id()",
    meta: _91id_93icNr2rgrF9Meta || {},
    alias: _91id_93icNr2rgrF9Meta?.alias || [],
    redirect: _91id_93icNr2rgrF9Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/p/[id].vue").then(m => m.default || m)
  },
  {
    name: registercFQtpaLLN0Meta?.name ?? "register",
    path: registercFQtpaLLN0Meta?.path ?? "/register",
    meta: registercFQtpaLLN0Meta || {},
    alias: registercFQtpaLLN0Meta?.alias || [],
    redirect: registercFQtpaLLN0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registercFQtpaLLN0Meta?.name ?? "register___pl",
    path: registercFQtpaLLN0Meta?.path ?? "/pl/register",
    meta: registercFQtpaLLN0Meta || {},
    alias: registercFQtpaLLN0Meta?.alias || [],
    redirect: registercFQtpaLLN0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registercFQtpaLLN0Meta?.name ?? "register___en",
    path: registercFQtpaLLN0Meta?.path ?? "/en/register",
    meta: registercFQtpaLLN0Meta || {},
    alias: registercFQtpaLLN0Meta?.alias || [],
    redirect: registercFQtpaLLN0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registercFQtpaLLN0Meta?.name ?? "register___ru",
    path: registercFQtpaLLN0Meta?.path ?? "/ru/register",
    meta: registercFQtpaLLN0Meta || {},
    alias: registercFQtpaLLN0Meta?.alias || [],
    redirect: registercFQtpaLLN0Meta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/node_modules/@shc/nuxt-shc-account-layer/pages/register.vue").then(m => m.default || m)
  },
  {
    name: sT4rojxn7RxMeta?.name ?? "s",
    path: sT4rojxn7RxMeta?.path ?? "/s",
    meta: sT4rojxn7RxMeta || {},
    alias: sT4rojxn7RxMeta?.alias || [],
    redirect: sT4rojxn7RxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/s.vue").then(m => m.default || m)
  },
  {
    name: sT4rojxn7RxMeta?.name ?? "s___pl",
    path: sT4rojxn7RxMeta?.path ?? "/pl/s",
    meta: sT4rojxn7RxMeta || {},
    alias: sT4rojxn7RxMeta?.alias || [],
    redirect: sT4rojxn7RxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/s.vue").then(m => m.default || m)
  },
  {
    name: sT4rojxn7RxMeta?.name ?? "s___en",
    path: sT4rojxn7RxMeta?.path ?? "/en/s",
    meta: sT4rojxn7RxMeta || {},
    alias: sT4rojxn7RxMeta?.alias || [],
    redirect: sT4rojxn7RxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/s.vue").then(m => m.default || m)
  },
  {
    name: sT4rojxn7RxMeta?.name ?? "s___ru",
    path: sT4rojxn7RxMeta?.path ?? "/ru/s",
    meta: sT4rojxn7RxMeta || {},
    alias: sT4rojxn7RxMeta?.alias || [],
    redirect: sT4rojxn7RxMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/pages/s.vue").then(m => m.default || m)
  },
  {
    name: storeLocatoriGipsFiiqFMeta?.name ?? "storeLocator",
    path: storeLocatoriGipsFiiqFMeta?.path ?? "/storeLocator",
    meta: storeLocatoriGipsFiiqFMeta || {},
    alias: storeLocatoriGipsFiiqFMeta?.alias || [],
    redirect: storeLocatoriGipsFiiqFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  },
  {
    name: storeLocatoriGipsFiiqFMeta?.name ?? "storeLocator___pl",
    path: storeLocatoriGipsFiiqFMeta?.path ?? "/pl/adresy-sklepow",
    meta: storeLocatoriGipsFiiqFMeta || {},
    alias: storeLocatoriGipsFiiqFMeta?.alias || [],
    redirect: storeLocatoriGipsFiiqFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  },
  {
    name: storeLocatoriGipsFiiqFMeta?.name ?? "storeLocator___en",
    path: storeLocatoriGipsFiiqFMeta?.path ?? "/en/adresy-sklepow",
    meta: storeLocatoriGipsFiiqFMeta || {},
    alias: storeLocatoriGipsFiiqFMeta?.alias || [],
    redirect: storeLocatoriGipsFiiqFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  },
  {
    name: storeLocatoriGipsFiiqFMeta?.name ?? "storeLocator___ru",
    path: storeLocatoriGipsFiiqFMeta?.path ?? "/ru/adresy-sklepow",
    meta: storeLocatoriGipsFiiqFMeta || {},
    alias: storeLocatoriGipsFiiqFMeta?.alias || [],
    redirect: storeLocatoriGipsFiiqFMeta?.redirect || undefined,
    component: () => import("/home/homeyou/shc/build/build-headless/108006/layers/nuxt-bbk-store-locator-layer/pages/storeLocator.vue").then(m => m.default || m)
  }
]